import { Controller } from "@hotwired/stimulus"
import { initTomSelect } from "../packs/application"

export default class extends Controller {
  connect() {
    initTomSelect(this.element);
  }

  disconnect() {
    if (this.element.tomselect) {
      this.element.tomselect.destroy();
    }
  }
}
